import PropTypes from 'prop-types';
import { createContext, useContext, useState } from 'react';

const initialErrorContext = null;

// Initialize Menu context object.
export const ErrorContext = createContext(initialErrorContext);

/**
 * Export useContext Hook.
 *
 * @return {Function} Woocommerce Context
 */
export function useErrorContext() {
    return useContext(ErrorContext);
}
type ErrorProviderProps = {
  children: React.ReactNode;
  value: any;
};

export default function ErrorProvider(props: ErrorProviderProps): JSX.Element {
    const { children } = props;

    // Error state management
    const [cartError, setCartError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    //Error types : error, warning, info, success
    const [errorType, SetErrorType] = useState('success');
    return (
        <ErrorContext.Provider
            value={{
                cartError,
                setCartError,
                errorMessage,
                setErrorMessage,
                errorType,
                SetErrorType,
            }}
        >
            {children}
        </ErrorContext.Provider>
    );
}

ErrorProvider.propTypes = {
    children: PropTypes.node,
    value: PropTypes.any,
};
